/**
 * MUI theme bridge — built from the same canonical tokens as tokens.css.
 * Keeps MUI components (Dialog, Drawer, Snackbar, ...) visually in sync
 * with the design system without per-usage `sx` overrides.
 */
import { createTheme } from "@mui/material/styles";
import { primitives, semantic } from "./tokens";

const font = primitives.font;

const muiTheme = createTheme({
  palette: {
    primary: {
      main: semantic["action-primary"],
      contrastText: semantic["text-on-action"],
    },
    secondary: {
      main: primitives.color["steel-gray-20"],
      contrastText: semantic["text-primary"],
    },
    error: {
      main: semantic.danger,
    },
    success: {
      main: semantic.success,
    },
    text: {
      primary: semantic["text-primary"],
      secondary: semantic["text-secondary"],
    },
    divider: semantic["border-default"],
    background: {
      default: semantic["bg-surface"],
      paper: semantic["bg-surface"],
    },
  },
  typography: {
    fontFamily: font["family-base"],
    // Figma type scale (Savills UDS)
    h1: { fontSize: font["size-26"], fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: font["size-22"], fontWeight: 700, lineHeight: 1.2 },
    body1: { fontSize: font["size-16"], fontWeight: 400 },
    body2: { fontSize: font["size-14"], fontWeight: 500 },
    caption: { fontSize: font["size-12"], fontWeight: 500 },
    button: { fontSize: font["size-12"], fontWeight: 500, textTransform: "none" },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: primitives.radius.md,
          boxShadow: primitives.shadow.card,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: primitives.radius.sm },
      },
    },
  },
});

export default muiTheme;
